import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "blog-details-area ptb-100" }
const _hoisted_2 = {
  key: 0,
  class: "container mw-1356"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-9 order-2 order-lg-1" }
const _hoisted_5 = { class: "blog-details-img mb-4" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "nav nav-tabs description-tabs" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "tab-content" }
const _hoisted_12 = { class: "pt-4" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "pt-4" }
const _hoisted_15 = { class: "col-lg-3 order-1 order-lg-2 mb-5 mb-lg-0" }
const _hoisted_16 = {
  key: 1,
  class: "container mw-1356"
}
const _hoisted_17 = { class: "text-center ptb-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarWidget = _resolveComponent("SidebarWidget")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.blog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.blog.image,
                  alt: _ctx.blog.title,
                  class: "w-100"
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.blog.title), 1),
              _createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", _hoisted_9, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'description' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'description'))
                  }, " الوصف ", 2)
                ]),
                _createElementVNode("li", _hoisted_10, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'reviews' }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'reviews'))
                  }, " المراجعات ", 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: "blog-details-content",
                    innerHTML: _ctx.blog.content
                  }, null, 8, _hoisted_13)
                ], 512), [
                  [_vShow, _ctx.activeTab === 'description']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_14, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "blog-details-content" }, [
                    _createElementVNode("h3", null, "المراجعات"),
                    _createElementVNode("p", null, "شاركنا رأيك حول هذه المقالة في التعليقات أدناه.")
                  ], -1)
                ]))], 512), [
                  [_vShow, _ctx.activeTab === 'reviews']
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_SidebarWidget)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[4] || (_cache[4] = _createElementVNode("h2", null, "المقال غير موجود", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", null, "عذرًا، لم نتمكن من العثور على المقال المطلوب.", -1)),
            _createVNode(_component_RouterLink, {
              to: "/blog",
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" العودة إلى المدونة ", -1)
              ]))]),
              _: 1
            })
          ])
        ]))
  ]))
}